import * as React from 'react';

type Props = {
  dataTestId?: string;
  children?: React.ReactNode;
};

const UserInputError = ({ children, dataTestId = 'validation-error' }: Props) => (
  <span data-test-id={dataTestId}>{children}</span>
);

const scrollToFirstUserInputError = (arg?: boolean | ScrollIntoViewOptions) => {
  const target = window.document.querySelectorAll(
    '[data-test=invalid-input]',
  )?.[0] as HTMLSpanElement;

  if (!target) {
    return;
  }

  target.scrollIntoView(arg);
};

export { UserInputError, scrollToFirstUserInputError };
